import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CareersPage = () => {
  // Job postings with title, description, and PDF filename
  const jobPostings = [
    {
      id: 'job1',
      title: 'District Coordinator',
      description: 'Responsible for coordinating rural development projects at the district level, monitoring implementation of various schemes and providing regular progress reports.',
      fileUrl: '/documents/dummy.pdf'
    },
    {
      id: 'job2',
      title: 'Training Officer',
      description: 'Design and deliver training programs for Panchayat officials on governance, financial management, and digital literacy to enhance their administrative capabilities.',
      fileUrl: '/documents/dummy.pdf'
    },
    {
      id: 'job3',
      title: 'Project Manager - Infrastructure',
      description: 'Oversee infrastructure development projects in rural areas, ensuring quality construction, timely completion, and adherence to budgetary allocations.',
      fileUrl: '/documents/dummy.pdf'
    },
    {
      id: 'job4',
      title: 'Data Analyst',
      description: 'Analyze data from various rural development initiatives, prepare performance metrics, and generate insights to improve program effectiveness and resource allocation.',
      fileUrl: '/documents/dummy.pdf'
    },
    {
      id: 'job5',
      title: 'Community Mobilizer',
      description: 'Work with rural communities to increase participation in development programs, facilitate community meetings, and ensure inclusive planning processes.',
      fileUrl: '/documents/dummy.pdf'
    },
    {
      id: 'job6',
      title: 'Technical Assistant - RRGSA',
      description: 'Provide technical support for the implementation of RRGSA schemes, assist in preparation of action plans, and conduct field visits for monitoring and evaluation.',
         fileUrl: '/documents/dummy.pdf'
    },
  ];

  // Function to handle direct PDF download
  const handleDownload = (fileUrl) => {
    // Create an anchor element
    const link = document.createElement('a');
    
    // Set the href to the file URL
    link.href = fileUrl;
    
    // Set the download attribute to force download instead of navigation
    link.setAttribute('download', '');
    
    // Append to the document
    document.body.appendChild(link);
    
    // Trigger click event
    link.click();
    
    // Remove the element after download is initiated
    document.body.removeChild(link);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <main className="flex-grow">
        {/* Hero Section */}
        <section className="relative py-10 bg-blue-800">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-2xl md:text-3xl font-bold text-white">Careers</h1>
              <div className="h-0.5 w-16 bg-white mt-2 mb-4"></div>
              <p className="text-white">
                Explore exciting career opportunities with the Rural Development and Panchayat Raj Department
              </p>
            </div>
          </div>
        </section>

        {/* Job Postings Section */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {jobPostings.map(job => (
                <div
                  key={job.id}
                  className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:shadow-lg"
                >
                  <div className="p-6">
                    <h2 className="text-xl font-bold text-blue-600 mb-2">{job.title}</h2>
                    <div className="h-0.5 w-16 bg-blue-600 mb-4"></div>
                    <p className="text-gray-700 mb-6">{job.description}</p>
                    <button
                      onClick={() => handleDownload(job.fileUrl)}
                      className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded flex items-center justify-center transition duration-300"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      Download Job Description
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-12 bg-gray-100">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Contact Us</h2>
            <p className="text-gray-600 max-w-2xl mx-auto mb-8">
              For any inquiries regarding career opportunities or application process, please reach out to us through the contact information below.
            </p>
            <div className="inline-flex items-center justify-center bg-white shadow-md rounded-lg px-6 py-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <a href="mailto:Crdtrg@gmail.com" className="text-blue-600 font-medium hover:underline">
                Crdtrg@gmail.com
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CareersPage;